import Icon, { IconVariants } from 'core/generic/elements/icons';
import styles from './award.module.scss';

type AwardProps = {
    title: string;
    subTitle?: string;
    trophyImageUri?: string;
};

const AwardsToIconsMap: { [key: string]: IconVariants } = {
    'Champions League Award': 'ChampionsLeagueFilled',
    'FA Cup Award': 'FaCupFilled',
    'Charity Shield Award': 'CharityShieldFilled',
    'Club World Cup Award': 'ClubWorldCupFilled',
    'League Cup Award': 'LeagueCupFilled',
    'Premier League Award': 'PremierLeagueFilled',
};

export const Award = ({ title, subTitle, trophyImageUri }: AwardProps) => {
    return (
        <div className={styles['award']}>
            <div className={styles['award__icon']}>
                {AwardsToIconsMap[title] && <Icon variant={AwardsToIconsMap[title]} />}
                {!AwardsToIconsMap[title] && trophyImageUri && (
                    <img
                        src={`${trophyImageUri}?width=88&height=88&mode=crop`}
                        alt={title}
                        width="44"
                        height="44"
                    />
                )}
            </div>
            <span className={`body-small`}>{subTitle}</span>
        </div>
    );
};
